import React from "react";
import { NavLink } from "react-router-dom";
import PlusIcon from "../../../assets/PlusIcon.png";
import "../AdminDashBoard.css";
import Edit from "../../../assets/Edit.svg";
import Delete from "../../../assets/Delete.svg";
import { TableContent } from "./data";

const Index = () => {
  return (
    <div className="row mt-5 pt-5">
      <div className="col-md-1"></div>
      {/* <!-- Wavpools --> */}
      <div className="col-11 TableMax-width mx-auto mt-md-0 mt-5 marginTop10">
        <div className="row">
          <div className="col-md-12 ">
            <h2 className="TableHeading ">Wavpools</h2>
          </div>
          <div className="col-md-12">
            {/* <!-- Tabs --> */}
            <div className="TabWrapper TabWrap_Noradius">
              <ul className="mb-3 StashTabs_Link">
                <ul
                  className="left_SLink nav nav-pills"
                  id="pills-tab"
                  role="tablist"
                >
                  <li className="nav-item" role="presentation">
                    <button
                      className="active"
                      id="pills-Wavpools1-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#pills-Wavpools1"
                      type="button"
                      role="tab"
                      aria-controls="pills-Wavpools1"
                      aria-selected="true"
                    >
                      Upcoming Wavpools
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className=""
                      id="pills-Wavpools2-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#pills-Wavpools2"
                      type="button"
                      role="tab"
                      aria-controls="pills-Wavpools2"
                      aria-selected="false"
                    >
                      Past Wavpools
                    </button>
                  </li>
                </ul>
                <ul className="Right_SLink">
                  <li>
                    <button className="CreateBtn">
                      Create Drop
                      <img
                        src={PlusIcon}
                        className="img-fluid ms-2 mt-1"
                        alt=""
                      />
                    </button>
                  </li>
                </ul>
              </ul>
              <div
                className="tab-content StashTabs_Content"
                id="pills-tabContent"
              >
                {/* <!-- 1 Tabs --> */}
                <div
                  className="tab-pane fade show active"
                  id="pills-Wavpools1"
                  role="tabpanel"
                  aria-labelledby="pills-Wavpools1-tab"
                >
                  {/* <!-- Table Header --> */}
                  <div className="TableHeader">
                    <div className="row row-cols-7 mx-0">
                      <div className="col">
                        <span className="">Vault No.</span>
                      </div>
                      <div className="col-2">
                        <span>No of Submisisions</span>
                      </div>
                      <div className="col-2">
                        <span>No of Stash Drops Used</span>
                      </div>
                      <div className="col">
                        <span>Genres included</span>
                      </div>
                      <div className="col-2">
                        <span>Date & Time (PST)</span>
                      </div>
                      <div className="col">
                        <span>First Edition NFT Mint Price</span>
                      </div>
                      <div className="col-1">
                        <span>Options</span>
                      </div>
                    </div>
                  </div>
                  {/* <!-- Table Content --> */}
                  {TableContent.map((item) => {
                    return (
                      <div className="TableContent">
                        <div className="row row-cols-7 mx-0">
                          <div className="col">
                            <span>{item.Vault}</span>
                          </div>
                          <div className="col-2">
                            <span className="fw-bold">
                              {item.NoSubmisisions}
                            </span>
                          </div>
                          <div className="col-2">
                            <span className="fw-bold">{item.NoStash}</span>
                          </div>
                          <div className="col">
                            <span className="fw-bold">{item.Genres}</span>
                          </div>
                          <div className="col-2">
                            <span>{item.Date}</span>
                          </div>
                          <div className="col">
                            <span>{item.FirstEdition}</span>
                          </div>
                          <div className="col-1">
                            <span className="me-4">
                              <NavLink to="">
                                <img
                                  src={Delete}
                                  className="img-fluid"
                                  alt=""
                                />
                              </NavLink>
                            </span>
                            <span>
                              <NavLink to="">
                                <img src={Edit} className="img-fluid" alt="" />
                              </NavLink>
                            </span>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                  {/* <!-- Table Footer --> */}
                  <div className="TableFooter">
                    <div className="row mx-0 justify-content-between">
                      <div className="col-3">
                        <button className="btn Btn_Previous">Previous</button>
                      </div>
                      <div className="col-3 d-flex justify-content-center">
                        <span className="Page_txt">Page 1 of 10</span>
                      </div>
                      <div className="col-3 d-flex justify-content-end">
                        <button className="btn Btn_Previous">Next</button>
                      </div>
                    </div>
                  </div>
                </div>
                {/* <!-- 2 Tabs --> */}
                <div
                  className="tab-pane fade"
                  id="pills-Wavpools2"
                  role="tabpanel"
                  aria-labelledby="pills-Wavpools2-tab"
                >
                  {/* <!-- Table Header --> */}
                  <div className="TableHeader">
                    <div className="row row-cols-7 mx-0">
                      <div className="col">
                        <span className="">Vault No.</span>
                      </div>
                      <div className="col-2">
                        <span>No of Submisisions</span>
                      </div>
                      <div className="col-2">
                        <span>No of Stash Drops Used</span>
                      </div>
                      <div className="col">
                        <span>Genres included</span>
                      </div>
                      <div className="col-2">
                        <span>Date & Time (PST)</span>
                      </div>
                      <div className="col">
                        <span>First Edition NFT Mint Price</span>
                      </div>
                      <div className="col-1">
                        <span>Options</span>
                      </div>
                    </div>
                  </div>
                  {/* <!-- Table Content --> */}
                  {TableContent.map((item) => {
                    return (
                      <div className="TableContent">
                        <div className="row row-cols-7 mx-0">
                          <div className="col">
                            <span>{item.Vault}</span>
                          </div>
                          <div className="col-2">
                            <span>{item.NoSubmisisions}</span>
                          </div>
                          <div className="col-2">
                            <span>{item.NoStash}</span>
                          </div>
                          <div className="col">
                            <span>{item.Genres}</span>
                          </div>
                          <div className="col-2">
                            <span>{item.Date}</span>
                          </div>
                          <div className="col">
                            <span>{item.FirstEdition}</span>
                          </div>
                          <div className="col-1">
                            <span className="me-4">
                              <NavLink to="">
                                <i
                                  className="fa fa-trash-o"
                                  aria-hidden="true"
                                ></i>
                              </NavLink>
                            </span>
                            <span>
                              <NavLink to="">
                                <i
                                  className="fa fa-pencil"
                                  aria-hidden="true"
                                ></i>
                              </NavLink>
                            </span>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                  {/* <!-- Table Footer --> */}
                  <div className="TableFooter">
                    <div className="row mx-0 justify-content-between">
                      <div className="col-3">
                        <button className="btn Btn_Previous">Previous</button>
                      </div>
                      <div className="col-3 d-flex justify-content-center">
                        <span className="Page_txt">Page 1 of 10</span>
                      </div>
                      <div className="col-3 d-flex justify-content-end">
                        <button className="btn Btn_Previous">Next</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* <!--ENd Tabs --> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Index;
